import { change, onSnapshot } from './helpers'

import {
  ImagesContext,
  ImagesState,
  ImageAddInterface,
  ImageUpdateInterface,
  ImageDeleteInterface,
} from '@/types/store'

import Image from '@/models/Image'

import { db } from '@/firebase'
import { id } from '@/types/models'
import { deleteImage, uploadImageToFirestore } from '@/firebase/storage'

const refBelongsToPlant = (
  refArray: Array<string | id>,
  gardenId: id,
  plantId: id,
  exactMatch = false
): boolean => {
  if (exactMatch) {
    return refArray.join('/') === `gardens/${gardenId}/plants/${plantId}`
  }

  return refArray.join('/').startsWith(`gardens/${gardenId}/plants/${plantId}`)
}

export default {
  namespaced: true,
  state: (): ImagesState => ({
    data: [],
    unbinds: [],
  }),
  getters: {
    all: (state: ImagesState) => state.data,
    inGarden: (state: ImagesState) => (gardenId: id) =>
      state.data.filter((image: Image) => image.gardenId === gardenId),
    find: (state: ImagesState) => (imageId: id) =>
      state.data.find((z: Image) => z.id === imageId),

    // plantImages: (state: ImagesState) => (gardenId: id, plantId: id) => state.data.filter((z: Image) => z.refs.includes(`gardens/${gardenId}/plants/${plantId}`)),
    plantImages:
      (state: ImagesState) =>
      (gardenId: id, plantId: id, exactMatch = false) =>
        state.data.filter((z: Image) =>
          z.refs.some((ref) =>
            refBelongsToPlant(ref.split('/'), gardenId, plantId, exactMatch)
          )
        ), // .includes(`gardens/${gardenId}/plants/${plantId}`)),
    plantHarvestImages:
      (state: ImagesState) => (gardenId: id, plantId: id, harvestId: id) =>
        state.data.filter((z: Image) =>
          z.refs.includes(
            [
              'gardens',
              gardenId,
              'plants',
              plantId,
              'harvests',
              harvestId,
            ].join('/')
          )
        ),
    logItemImages: (state: ImagesState) => (gardenId: id, logItemId: id) =>
      state.data.filter((z: Image) =>
        z.refs.includes(`gardens/${gardenId}/log/${logItemId}`)
      ),
  },
  mutations: {
    change,
    clear(state: ImagesState) {
      state.data = []
    },

    addUnbind(state: ImagesState, val: () => void) {
      state.unbinds.push(val)
    },
  },
  actions: {
    bind(context: ImagesContext, gardenId: id) {
      // unsubscribe can be called to stop listening for changes
      const unsubscribe = db.onCollectionSnapshot(
        db.query(
          db
            .collection('gardens', gardenId, 'images')
            .withConverter(Image.firestoreConverter(gardenId))
        ),
        (ref) => onSnapshot(context, ref)
      )

      // save unbind function to store
      context.commit('addUnbind', unsubscribe)
    },
    unbind(context: ImagesContext) {
      // unsubscribe from firestore
      context.state.unbinds.forEach((fn) => fn())

      // clear from vuex store
      context.commit('clear')

      // TODO: unbind children based on collections() instead of root
    },
    add(
      context: ImagesContext,
      { file, gardenId, refs, note }: ImageAddInterface
    ) {
      return uploadImageToFirestore(file, gardenId, refs, note)
    },
    update(
      context: ImagesContext,
      { gardenId, id, updates }: ImageUpdateInterface
    ) {
      return db.updateDoc(
        db
          .doc('gardens', gardenId, 'images', id)
          .withConverter(Image.firestoreConverter(gardenId)),
        updates
      )
    },
    delete(
      context: ImagesContext,
      { gardenId, imageId }: ImageDeleteInterface
    ) {
      return deleteImage(gardenId, imageId)
    },
  },
}
